import React from 'react';
import i18n from '../../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../../Form/FormField";
import FormDate from "../../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {Hidden, withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../../Form/utils";
import FormCheck from "../../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../../Form/DeleteButton";
import FormSelect from "../../Form/FormSelect";
import Divider from '@material-ui/core/Divider';
import MediaDropButton from '../../Media/DropButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from "@material-ui/core/Typography";
import FormNumber from "../../Form/FormNumber";
import SignatureCanvas from 'react-signature-canvas';
import FormRadio from "../../Form/FormRadio";

class IndustrialVehicles extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false,
            signatureData1: '',
            signatureData2: '',
            updatingFields: false,
            examination1: '',
            examination2: '',
            examination3: '',
            examination4: '',
            examination5: '',
            examination6: '',
            examination7: '',
        };
    }

    sigCanvas1 = {}
    sigCanvas2 = {}

    handleSign1 = () => {
        this.setState({signatureData1: this.sigCanvas1.toDataURL()});
    }
    handleSign2 = () => {
        this.setState({signatureData2: this.sigCanvas2.toDataURL()});
    }

    render() {
        const {
            classes,
            values,
            protocol,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            formUrl,
            customer,
            structure,
            uploadConfig,
        } = this.props;

        values.signature1 = this.state.signatureData1
        values.signature2 = this.state.signatureData2
        if(protocol && protocol.is_correction) {
            values.is_correction = true;
            values.from_protocol_id = protocol.id;
        }

        return (
            <React.Fragment>
                <Grid item>
                    <Grid container xs={12} spacing={24} alignItems="center">
                        <Grid item xs={2}>
                            <Typography className={classes.textRight} component={"div"}
                                        variant={"body2"}>
                                Hersteller:
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="producer"
                                // label='Hersteller'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.producer}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={2}>
                            <Typography className={classes.textRight} component={"div"}
                                        variant={"body2"}>
                                Geräteart/-typ:
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="type"
                                // label='Hersteller'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={2}>
                            <Typography className={classes.textRight} component={"div"}
                                        variant={"body2"}>
                                Baujahr:
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="number"
                                name="construction_year"
                                // label='Hersteller'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.construction_year}
                                inputProps={{
                                    max : 2100,
                                }}
                            />
                            {/*<FormNumber*/}
                            {/*    type="text"*/}
                            {/*    name="construction_year"*/}
                            {/*    onChange={handleChange}*/}
                            {/*    value={this.state.construction_year}*/}
                            {/*    fixedDecimalScale={false}*/}
                            {/*    thousandSeparator={''}*/}
                            {/*/>*/}
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={2}>
                            <Typography className={classes.textRight} component={"div"}
                                        variant={"body2"}>
                                Seriennummer:
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="serial_number"
                                // label='Hersteller'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.serial_number}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={2}>
                            <Typography className={classes.textRight} component={"div"}
                                        variant={"body2"}>
                                Stand-/Einbauort:
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="location"
                                // label='Hersteller'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.location}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={2}>
                            <Typography className={classes.textRight} component={"div"}
                                        variant={"body2"}>
                                Inventarnummer:
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="inventory_number"
                                // label='Hersteller'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.inventory_number}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={2}>
                            <Typography className={classes.textRight} component={"div"}
                                        variant={"body2"}>
                                Hubkraft:
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <FormField
                                type="text"
                                name="lifting_capacity"
                                // label='Hersteller'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.lifting_capacity}
                                inputProps={{
                                    maxLength : 20,
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Grid item xs={12}>
                    <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={7}>
                            <Typography component={"div"}
                                        variant={"body2"}>
                                Prüfung der Gelenke, Bolzen, Verschraubungen
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <FormRadio
                                name="examination1"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'Mängel'
                                    },
                                    {
                                        value : 'not_applicable',
                                        label : 'nicht zutreffend'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                classNameRadio={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.examination1 || ''}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={7}>
                            <Typography component={"div"}
                                        variant={"body2"}>
                                Prüfung der Radlager auf Leichtigkeit und Spiel
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <FormRadio
                                name="examination2"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'Mängel'
                                    },
                                    {
                                        value : 'not_applicable',
                                        label : 'nicht zutreffend'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                classNameRadio={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.examination2 || ''}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={7}>
                            <Typography component={"div"}
                                        variant={"body2"}>
                                Prüfung der Lenkung auf Leichtigkeit und Spiel
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <FormRadio
                                name="examination3"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'Mängel'
                                    },
                                    {
                                        value : 'not_applicable',
                                        label : 'nicht zutreffend'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                classNameRadio={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.examination3 || ''}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={7}>
                            <Typography component={"div"}
                                        variant={"body2"}>
                                Sichtprüfung der Schweißnähte
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <FormRadio
                                name="examination4"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'Mängel'
                                    },
                                    {
                                        value : 'not_applicable',
                                        label : 'nicht zutreffend'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                classNameRadio={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.examination4 || ''}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={7}>
                            <Typography component={"div"}
                                        variant={"body2"}>
                                Prüfung der Bremsen
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <FormRadio
                                name="examination5"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'Mängel'
                                    },
                                    {
                                        value : 'not_applicable',
                                        label : 'nicht zutreffend'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                classNameRadio={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.examination5 || ''}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={7}>
                            <Typography component={"div"}
                                        variant={"body2"}>
                                Prüfung der Hydraulikanlagen auf Dichtigkeit bei Nennlast und auf einwandfreie
                                Betätigung durch Hebel. (Das mit der Nennlast hochgefahrene Lastaufnahmemittel darf
                                sich in 5 Minuten um nicht mehr als 40mm unbeabsichtigt senken)
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <FormRadio
                                name="examination6"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'Mängel'
                                    },
                                    {
                                        value : 'not_applicable',
                                        label : 'nicht zutreffend'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                classNameRadio={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.examination6 || ''}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={7}>
                            <Typography component={"div"}
                                        variant={"body2"}>
                                Allgemeine Sichtprüfung auf Verschleiss und unsachgemäße Veränderungen
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <FormRadio
                                name="examination7"
                                options={[
                                    {
                                        value : 'okay',
                                        label : 'i.O.'
                                    },
                                    {
                                        value : 'deficiency',
                                        label : 'Mängel'
                                    },
                                    {
                                        value : 'not_applicable',
                                        label : 'nicht zutreffend'
                                    }
                                ]}
                                onChange={handleChange}
                                className={classes.formRadioSelection}
                                classNameRadio={classes.formSelection}
                                onBlur={handleBlur}
                                value={values.examination7 || ''}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                        <Grid item xs={10}>
                            <FormField
                                type="text"
                                name="notations"
                                label='Befund / Mängel / Bemerkungen'
                                multiline
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.notations}
                            />
                        </Grid>
                        <Grid item xs={1}>&nbsp;</Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Grid item xs={12}>
                    <FormRadio
                        name="inspection_tag"
                        options={[
                            {
                                value : 'yes',
                                label : 'Prüfplakette erteilt',
                            },
                            {
                                value : 'no',
                                label : 'Prüfplakette nicht erteilt',
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadio}
                        classNameRadio={classes.formButton}
                        onBlur={handleBlur}
                        value={values.inspection_tag}
                    />
                </Grid>
                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Datum:
                    </Typography>
                </Grid>
                <Grid item md={3} sm={4} justify="center">
                    <FormDate
                        type="date"
                        name="current_date"
                        // label={i18n.get('cooperations.day_last_appointment')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.current_date}
                    />
                </Grid>
                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Nächster Prüftermin:
                    </Typography>
                </Grid>
                <Grid item md={3} sm={4} justify="center">
                    <FormDate
                        type="date"
                        name="next_date"
                        // label={i18n.get('cooperations.day_last_appointment')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.next_date}
                    />
                </Grid>

                <Hidden smDown>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas1 = ref }}
                                    onEnd={this.handleSign1}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={6} sm={12} xs={12}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas2 = ref }}
                                    onEnd={this.handleSign2}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Auftraggeber
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Prüfer
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                </Hidden>

                <Hidden mdUp>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas1 = ref }}
                            onEnd={this.handleSign1}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Auftraggeber
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>&nbsp;</Grid>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas2 = ref }}
                            onEnd={this.handleSign2}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Prüfer
                        </Typography>
                    </Grid>
                </Hidden>
            </React.Fragment>
        )
    }
}

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    },
    textCenter: {
        textAlign: "center",
    },
    textRight: {
        textAlign: "right",
    },
    gridBorder: {
        border: '1px solid black',
    },
    formRadio: {
        flexDirection: "row",
        marginLeft: '100px'
    },
    formRadioSelection: {
        flexDirection: "row",
    },
    formButton: {
    },
    formSelection: {
    }
});

export default withStyles(styles)(IndustrialVehicles)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Protocols/Protocols/IndustrialVehicles.js